import { render, staticRenderFns } from "./number-renderer.vue?vue&type=template&id=29dc5c00&"
import script from "./number-renderer.vue?vue&type=script&lang=js&"
export * from "./number-renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports